/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  LessonPlanCurriculumReferences,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Curriculum documents a lesson plan is based on
 */
export const getLessonPlanCurriculumReferences = (
    planId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      planId = toValue(planId);

      return axiosClient<LessonPlanCurriculumReferences>(
      {url: `/lesson_plan/plans/${planId}/curriculum_references`, method: 'GET', signal
    },
      );
    }




export const getGetLessonPlanCurriculumReferencesQueryKey = (planId: MaybeRefOrGetter<string>,) => {
    return [
    'lesson_plan','plans',planId,'curriculum_references'
    ] as const;
    }


export const getGetLessonPlanCurriculumReferencesQueryOptions = <TData = Awaited<ReturnType<typeof getLessonPlanCurriculumReferences>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(planId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLessonPlanCurriculumReferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetLessonPlanCurriculumReferencesQueryKey(planId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLessonPlanCurriculumReferences>>> = ({ signal }) => getLessonPlanCurriculumReferences(planId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(planId) !== null && toValue(planId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLessonPlanCurriculumReferences>>, TError, TData>
}

export type GetLessonPlanCurriculumReferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getLessonPlanCurriculumReferences>>>
export type GetLessonPlanCurriculumReferencesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Curriculum documents a lesson plan is based on
 */

export function useGetLessonPlanCurriculumReferences<TData = Awaited<ReturnType<typeof getLessonPlanCurriculumReferences>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 planId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLessonPlanCurriculumReferences>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLessonPlanCurriculumReferencesQueryOptions(planId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






